import axiosInstance from "./axiosInstance";
import { User } from "../components/UserContext";

// api/auth.ts
export const getCurrentUser = async (): Promise<User> => {
  const { data } = await axiosInstance.get<User>("/me");
  return data;
};



export const loginRequest = async (username: string, password: string) => {
  const response = await axiosInstance.post<{ access_token: string }>("/login", {
    username,
    password,
  });
  return response.data.access_token;
};
export const logoutRequest = async () => {
  await axiosInstance.post("/logout");
  localStorage.clear(); // Очищаем токен и всё остальное
};